import { useCallback } from "react";
import { useSetRecoilState } from "recoil";
import { packagingOutdatedNoticePendingState } from "@/store/packaging-outdated-notice";
import { responseHasPackItem } from "@/pages-components/packaging/packaging-outdated-notice.utils";

/**
 * Queues a one-shot packaging-outdated notice when an API payload includes hasPACKItem.
 */
export const useNotifyPackagingOutdated = () => {
  const setPackagingOutdatedNoticePending = useSetRecoilState(
    packagingOutdatedNoticePendingState,
  );

  return useCallback(
    (payload: unknown) => {
      if (responseHasPackItem(payload)) {
        setPackagingOutdatedNoticePending(true);
      }
    },
    [setPackagingOutdatedNoticePending],
  );
};
